import $ from 'jquery'

export default class Chat {

    constructor(params)
    {
        this.params = params;
        try {
            this.onlineSchedules = JSON.parse(this.params.onlineSchedules);
            this.offlineSchedules = JSON.parse(this.params.offlineSchedules);
        } catch (e) {
            // Don't show if schedule can't be parsed
            this.onlineSchedules = [];
            this.offlineSchedules = [{"time": "0000-2359", "day": "Monday-Sunday", "city": "Europe/London"}];
            console.error('FAILED TO PARSE SCHEDULE: ' + e.message);
        }
        this.setupSelectors();
    }

    setupSelectors()
    {
        this.$chatButton = $('#chat-button-container');
        this.$chatButtonLaunch = $('#chat-button-launch');
        this.chatWidget = 'webchat-widget';
        this.chatContainer = 'webchat-container';
        this.$closeButton = $('.close-btn');
        this.$chatContainer = $('#' + this.chatContainer);
        this.$chatForm = $('#start-chat-form');
        this.$startButton = $('#start-chat');
        this.$showCallback = $('#show-callback');
        this.$callbackForm = $('#start-callback-form');
        this.$requestCallback = $('#request-callback');
        this.$showCallback = $('#show-callback');
    }

    loadChat()
    {
        let dataLayer = window.dataLayer = window.dataLayer || [];
        let queue = sessionStorage.getItem('webchat.queue') || '';
        let firstName = sessionStorage.getItem('webchat.firstName') || 'anonymous';
        let me = this;
        let chatConfig = {
            "webchatAppUrl": "https://apps.mypurecloud.ie/webchat",
            "webchatServiceUrl": "https://realtime.mypurecloud.ie:443",
            "orgId": me.params.orgId,
            "orgGuid": me.params.orgGuid,
            "orgName": me.params.orgName,
            "queueName": queue,
            "logLevel": 'WARN',
            "locale": "en",
            "data": {
                "phoneNumber": dataLayer[0].visitorTel,
                "customField1Label": "PageCategory",
                "customField1": dataLayer[0].pageCategory,
                "customField2Label": "PageSubCategory",
                "customField2":  dataLayer[0].pageSubCategory,
                "customField3Label": "PageTitle",
                "customField3": dataLayer[0].pageTitle,
                "email": dataLayer[0].visitorEmail,
                "firstName": firstName
            },
            "companyLogo": {
                "width": 175,
                "height": 145,
                "url": "https://d2kz53n3bzvihv.cloudfront.net/media/gbu0/ofl-leaf-175x.jpg"
            },
            "companyLogoSmall": {
                "width": 400,
                "height": 332,
                "url": "https://d2kz53n3bzvihv.cloudfront.net/media/gbu0/ofl-leaf-400x.jpg"
            },
            "welcomeMessage": 'Welcome to Oak Furnitureland web chat',
            "cssClass": "webchat-frame",
            "css": {
                "width": "100%",
                "height": "100%"
            },
            "chatNowElement": "chat-button-container",
            "onlineSchedules": me.onlineSchedules,
            "offlineSchedules": me.offlineSchedules,
            "reconnectEnabled": true,
            "reconnectOrigins": [window.location.origin]
        };

        if (me.params.isAvailable) {
            me.sendEvent('Shown');
        } else {
            me.$chatButton.hide();
        }

        if (me.params.callbackEnabled) {
            me.$showCallback.show();
        }

        ININ.webchat.create(chatConfig, function (err, webchat) {
            if (err) {
                console.error(err);
                throw err;
            }

            $('#chat-button').on('click', function () {
                $('#chat-button').hide();
                $('#webchat-container').show();
            });

            $('#chat-button-launch').on('click', function () {
                $('#chat-button').hide();
                $('#webchat-container').show();
            })

            $('#webchat-container').find('.close-btn').on('click', function (e) {
                e.preventDefault();
                $('#webchat-container').hide();
                $('#chat-button').show();
            })

            me.$startButton.on('click', function (e) {
                e.preventDefault();

                // Update first name from input, store in session for reconnect
                let data = webchat.getConfig().getData();
                let firstName = me.$chatForm.find('input[name="firstName"]').val() != ''
                    ? me.$chatForm.find('input[name="firstName"]').val()
                    : 'Anonymous';
                sessionStorage.setItem('webchat.firstName', firstName);
                data.firstName = firstName;
                webchat.getConfig().setData(data);

                // Update queue from input, store in session for reconnect
                let queue = me.$chatForm.find('select[name="queue"]').val();
                sessionStorage.setItem('webchat.queue', queue);
                webchat.updateConfig({
                    'queueName': queue
                });

                me.startChatDisplay();
                webchat.renderFrame({
                    containerEl: me.chatWidget
                });
            })

            webchat.chatStarted = function () {
                //Code to run when the chat is started
                me.sendEvent('Started');
            }

            webchat.chatConnectedToAgent = function () {
                //Code to run when the chat is connected to an agent
                me.sendEvent('Connected');
            }

            webchat.chatEnded = function () {
                //Code to run when chat ends.
                me.$chatContainer.hide();
                me.sendEvent('Ended');
            }

            if (webchat.isAutoJoined()) {
                me.startChatDisplay();
            }
        })

        me.$showCallback.on('click', function (e) {
            e.preventDefault();
            me.$callbackForm.show();
            me.$chatForm.hide();
        });

        me.$requestCallback.on('click', function (e) {
            e.preventDefault();
            let valid = me.validateCallbackForm();
            if (valid !== true) {
                alert(valid);
                return;
            }
            me.sendCallbackForm();
        });

    }

    validateCallbackForm()
    {
        if (this.$callbackForm.find('input[name="phoneNumber"]').val().length < 10) {
            return 'Please enter a full phone number including area code';
        }
        return true;
    }

    sendCallbackForm()
    {
        let me = this;
        $.ajax({
            type: 'POST',
            url: '/index.php',
            data: this.$callbackForm.serialize(),
            success: function (data) {
                alert(data.message);
                me.hideChatDisplay();
            },
            error: function (r) {
                alert('Sorry, your callback request failed');
            }
        });
    }

    startChatDisplay()
    {
        this.$chatButton.hide();
        this.$chatForm.hide();
        this.$closeButton.hide();
        this.$chatContainer.show();
        this.$chatContainer.addClass('chat-started');
    }

    hideChatDisplay()
    {
        this.$chatContainer.hide();
        this.$chatButton.show();
        this.$callbackForm.hide();
        this.$chatForm.show();
    }

    sendEvent(name)
    {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'UAEvent',
            'eventCategory': 'Webchat',
            'eventAction': this.params.queue,
            'eventLabel': name
        });
    }

    init()
    {
        let me = this;

        window.PURECLOUD_WEBCHAT_FRAME_CONFIG = {
            containerEl: this.chatWidget
        };

        // Add PureCloud external script, then start chat
        (function (d, script) {
            script = d.createElement('script');
            script.async = true;
            script.onload = function () {
                $(document).ready(
                    me.loadChat()
                );
            };
            script.src = 'https://apps.mypurecloud.ie/webchat/jsapi-v1.js';
            script.id = 'purecloud-webchat-js';
            script.setAttribute('region', 'eu-west-1');
            script.setAttribute('org-guid', me.params.orgGuid);
            script.setAttribute('deployment-key', me.params.deploymentKey);
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));
    }
}
